import React, {Component} from 'react';
import ReactGA from 'react-ga';
import {
        CardElement,
        injectStripe
        // PaymentRequestButtonElement
        } from 'react-stripe-elements';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import SelectButton from '../../components/icon/SelectButton';
import * as util from '../../utils/util';
import { productTypeUpdated, RESPONSE_STATUS } from '../../utils/constants';
// import { FaCheckCircle, FaCircle, FaFacebook, FaInstagram } from 'react-icons/fa';
import ReactPixel from 'react-facebook-pixel';
import * as zenscroll from 'zenscroll';

import './GateFee.css';
import Api from '../../utils/api';
import { stateData } from '../../data/states';
import {isMobile} from "../../utils/util"

const indexMapThreeFive = {13:true,14:true};
const indexMapProducts = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,11:true,12:true,15:true};
const indexMapProductsRef = {1:"Cleanser",2:"Toner",3:"Moisturizer",4:"SPF",5:"Serum",6:"Eye Cream",7:"Exfoliator",8:"Mask",11:"Make-Up Remover",12:"Treatment",15:"Supplement"};
const indexMapProductsFile = {1:"cleanser",2:"toner",3:"moisturizer",4:"spf",5:"serum",6:"eye-cream",7:"exfoliator",8:"mask",11:"makeup-remover",12:"treatment",15:"supplement"};


class GateFeeProcessing extends Component {
    constructor(props) {
        super(props);

        this.idempotencyKey = Api.getUUID();

        this.changeStepOneStep = this.changeStepOneStep.bind(this);
        this.changeStepTwoStep = this.changeStepTwoStep.bind(this);
        this.handleClickDot = this.handleClickDot.bind(this);
        this.handleSubmitStepTwo = this.handleSubmitStepTwo.bind(this);
        this.handleProgressBar = this.handleProgressBar.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePayment = this.handlePayment.bind(this);
        this.selectPasIcon = this.selectPasIcon.bind(this);
        this.deselectPasIcon = this.deselectPasIcon.bind(this);
        this.saveProducts = this.saveProducts.bind(this);
        this.handleDropdown = this.handleDropdown.bind(this);
        this.handleChangePhoneInput = this.handleChangePhoneInput.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleResend = this.handleResend.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleConfirmInput = this.handleConfirmInput.bind(this);
        this.handlePhoneNumSubmit = this.handlePhoneNumSubmit.bind(this);
        this.handleConfirmCodeSubmit = this.handleConfirmCodeSubmit.bind(this);
        this.handleSubmitStepOne = this.handleSubmitStepOne.bind(this);
        this.handleCheckChangeShippingAddress = this.handleCheckChangeShippingAddress.bind(this);
        this.checkIfPromoCodeExists = this.checkIfPromoCodeExists.bind(this);
        this.redeemGiftCardInFull = this.redeemGiftCardInFull.bind(this);
        this.saveGateFeeAmount = this.saveGateFeeAmount.bind(this);

        const paymentRequest = this.props.stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: 'Gate Fee',
                amount: 1000
            },
        });

        paymentRequest.on('token', ({complete, token, ...data}) => {
            this.handlePayment(token);
            complete('success');
        });
        paymentRequest.canMakePayment().then((result) => this.setState({ showPaymentRequestButton: !!result }));

        this.state = {
            stepOneStep: 0,
            stepTwoStep: 0,
            showThankYou: props.showThankYouMessage,
            phoneNumber: '',
            confirmCode: null,
            budget: null,
            isEditingProducts: false,
            inputValue: null,
            productTypes: [],
            defaultPurchaseConfirmed: false,
            codeMatch: true,
            paymentRequest: paymentRequest,
            showPaymentRequestButton: false,
            country: '',
            region: '',
            fnameShipping: '',
            lnameShipping: '',
            addressOneShipping: '',
            addressTwoShipping: '',
            cityShipping: '',
            zipShipping: '',
            name: '',
            addressOne: '',
            addressTwo: '',
            city: '',
            zip: '',
            disablePurchaseButton: false,
            showShippingAddressSection: false,
            promoCode: '',
            promoCodeSaved: '',
            amountAvailableForDiscount: 0,
            showPromoSuccessMessage: false,
            promoCodeError: '',
            discountCodes: [],
            discountType: '',
            discountExpirationDate: '',
            disablePromoButton: false,
            phoneCountry:''
        }
    }

    componentWillMount() {
        const userId = localStorage.getItem("user_id");
        if (userId) {
            this.fetchResult();
            var user_account_info = localStorage.getItem("user_account_info");
            if(util.isJSON(user_account_info)){
               let user_account_infoJson = JSON.parse(user_account_info);
               this.setState({
                phoneCountry: util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1) 
               })
               localStorage.setItem("phoneCountry",util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1) );
               localStorage.setItem("phoneCountryNumber",user_account_infoJson.region ? user_account_infoJson.region.id : 1);
            }

            
            if(this.state.showThankYou){
                let anchor = document.getElementById("chat-button");
                zenscroll.center(anchor);
            }
        }
    }

    componentDidMount() {
        this.changeStepOneStep();
        this.handleProgressBar();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.showThankYouMessage !== this.props.showThankYouMessage) {
            this.setState({ showThankYou: this.props.showThankYouMessage });
            if (this.state.showThankYou) {
                let anchor = document.getElementById("weVeReceived-js");
                zenscroll.center(anchor);
            }
        }
        if (prevProps.phoneNumber !== this.props.phoneNumber) {
            this.setState({ phoneNumber: this.props.phoneNumber });
        }

        if (prevState.country !== this.state.country) {
            this.setState({ region: "" });
        }

        if (prevState.countryShipping !== this.state.countryShipping) {
            this.setState({ regionShipping: "" });
        }

        // if (this.state.stepTwoStep <= 0) {
        //     let anchor = document.getElementById("progress-bar-container");
        //     zenscroll.center(anchor);
        // }
    }


    gtag_report_conversion_submitPayment(url) {
        let callback = function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
            }
        };
        if(window.gtag)
        window.gtag('event', 'conversion', {
              'send_to': 'AW-782420739/XDIuCJWZ4YwBEIOWi_UC',
              'event_callback': callback
        });
        return false;
    }

    

    //Get user budget and selected products
    fetchResult() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/surveys/result?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({
                inputValue: responseJson.selectedBudgetId,
                productTypes: responseJson.productTypes.length > 0 && (responseJson.productTypes.indexOf(9) === -1 && responseJson.productTypes.indexOf(10) === -1) ? responseJson.productTypes : [1,2,3]
           });
            let indexNine = this.state.productTypes.indexOf(9);
            let indexTen = this.state.productTypes.indexOf(10);
            if (indexNine !== -1) this.state.productTypes.splice(indexNine, 1); 
            if (indexTen !== -1) this.state.productTypes.splice(indexTen, 1);
        }).catch(function(err) {
            console.log("There was a problem getting your survey result. Please try again.");
        });
    }


    //Add paid user to Airtable via Zapier
    addPaidUsersToZapier(firstName, lastName, phoneNumber, timeStamp, email, paidAmount) {
        const url = 'https://api.airtable.com/v0/app1i1EUDcShUEpYn/gate%20fee%20users';
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + process.env.REACT_APP_AIRTABLE_API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "fields": {
                    "First Name": firstName,
                    "Last Name": lastName,
                    "Phone": phoneNumber,
                    "Timestamp": this.convertToStandardTime(timeStamp),
                    "Email": email,
                    "PaidAmount": paidAmount
                }
            })
        });
    }

    convertToStandardTime(timestamp) {
        var d = new Date(timestamp * 1000),    // Convert the passed timestamp to milliseconds
            yyyy = d.getFullYear(),
            mm = ('0' + (d.getMonth() + 1)).slice(-2),  // Months are zero based. Add leading 0.
            dd = ('0' + d.getDate()).slice(-2),         // Add leading 0.
            hh = d.getHours(),
            h = hh,
            min = ('0' + d.getMinutes()).slice(-2),     // Add leading 0.
            ampm = 'AM',
            time;

        if (hh > 12) {
            h = hh - 12;
            ampm = 'PM';
        } else if (hh === 12) {
            h = 12;
            ampm = 'PM';
        } else if (hh === 0) {
            h = 12;
        }

        // ie: 2013-02-18, 8:35 AM
        time = yyyy + '-' + mm + '-' + dd + ', ' + h + ':' + min + ' ' + ampm;

        return time;
    }

    /*** PROMO CODE FLOW ***/

    checkIfPromoCodeExists(e) {
        e.preventDefault();
        
        if (this.state.promoCode.length === 0) {
            alert('No promo code entered. Please enter a promo code.');
            return;
        } 

        this.setState({ disablePromoButton: true });

        // this.checkIfPreviouslyUsedDiscountCode(this.state.promoCode).then(response => response)
        this.checkIfPreviouslyUsedDiscountCode(this.state.promoCode)
        .then(response => {
            // console.log(response);
            if (response) {
                return this.setState({ disablePromoButton: false, showPromoSuccessMessage: true, promoCodeError: "Promo code only has already been used." });
            
            } else {
                const url = '/api/shopify/promo-price-rule?code=' + this.state.promoCode;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth-token': localStorage.getItem('auth_token')
                    }
                })
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else if (response.status >= 400 && response.status < 500) {
                        this.setState({ disablePromoButton: false, showPromoSuccessMessage: true, promoCodeError: "Promo code does not exist." });
                    } else {
                        this.setState({ disablePromoButton: false, showPromoSuccessMessage: true, promoCodeError: "There was a problem checking the eligibility of your promo code." });
                    }
                })
                .then((resJson) => {
                    if (Math.abs(resJson.price_rule.value) > 0) {
                        let discountCodes = this.state.discountCodes;
                        let expirationDate = resJson.price_rule.ends_at ? resJson.price_rule.ends_at : null;

                        if (resJson.price_rule.prerequisite_subtotal_range && (resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to >= parseFloat(this.props.price))) {
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ promoCodeError: "Promo code " + this.state.promoCodeSaved + " only applies to purchases of $" +  parseFloat(resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to).toFixed(2) + " or more." });
                            });
                            return;
                        }

                        if (this.checkIfPromoCodeHasExpired(expirationDate)) {
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ disablePromoButton: false, promoCodeError: "Promo code " + this.state.promoCode + " has expired." });
                            });
                            return;
                        }

                        if (discountCodes.indexOf(this.state.promoCode) < 0) {
                            discountCodes.push(this.state.promoCode);
                        } else {
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ disablePromoButton: false, promoCodeError: "Promo code " + this.state.promoCode + " has already been redeemed." });
                            });
                            return;
                        }


                        this.setState({ 
                            amountAvailableForDiscount: Math.abs(resJson.price_rule.value),
                            discountType: resJson.price_rule.value_type,
                            // discountExpirationDate: resJson.price_rule.ends_at ? resJson.price_rule.ends_at : "",
                            discountMinimumAmount: resJson.price_rule.prequisite_subtotal_range,
                            discountOncePerCustomer: resJson.price_rule.once_per_customer,
                            showPromoSuccessMessage: true,
                            promoCodeSaved: this.state.promoCode,
                            discountCodes: discountCodes
                        });
                    } else {
                        this.setState({ showPromoSuccessMessage: true, promoCodeSaved: this.state.promoCode }, () => {
                            this.setState({ promoCodeError: "Promo code " + this.state.promoCodeSaved + " has already been redeemed." });
                        });
                    }   
                })
                .catch((err) => {
                    console.log(err);
                });
            }
        })
    }

    redeemGiftCardInFull() {
        const userId = localStorage.getItem("user_id");
        const url = '/api/used-discount-codes';
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem('auth_token')
            },
            body: JSON.stringify({
                "code": this.state.promoCodeSaved,
                "userId": userId
            })
        })
        .then((response) => {
            if (response.status >= 400 && response.status < 500) {
                throw new Error("Promo code was already redeemed.");
            } else if (response.status >= 500) {
                throw new Error("Server error.");
            } else {
                return;
            }
        })
        .catch((err) => {
            alert('There was an error redeeming your promo code: ' + err);
        });
    }

    checkIfPreviouslyUsedDiscountCode = (code) => {
        const userId = localStorage.getItem("user_id");
        const url = `/api/used-discount-codes/exist?user-id=${ userId }&code=${ code }`;
        return fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem('auth_token')
            }
        })
        .then(response => response.json())
        .then(resJson => {
            return resJson;
        })
        .catch(err => alert("There was a problem checking your discount code."));
    }

    checkIfPromoCodeHasExpired = (date) => {
        if (date === null) {
            return false;
        }
        const expireTime = new Date(date);
        const currentTime = new Date();

        return expireTime.getTime() - currentTime.getTime() < 0;
    }

    /*** END PROMO CODE FLOW ***/


    

    /*** STEP 1 ***/

    changeStepOneStep() {
        let stepOneStep = this.state.stepOneStep;
        stepOneStep++;
        this.setState({ stepOneStep: stepOneStep}, function() {
            if (stepOneStep === 4) {
                setTimeout(this.changeStepOneStep, 2500);
            } else if (stepOneStep === 5) {
                setTimeout(this.changeStepTwoStep, 1500);
            }
        });
    }

    changeStepTwoStep() {
        let stepTwoStep = this.state.stepTwoStep;
        stepTwoStep++;
        this.setState({ stepTwoStep: stepTwoStep});
        if (stepTwoStep === 1) {
            // let anchor = document.getElementById("payment-block");
            let anchor = document.getElementById("checkout-block-content-products");
            zenscroll.center(anchor);
        }

        if (stepTwoStep === 3) {
            let anchorSuccess = document.getElementById("gate-fee-checkout");
            zenscroll.center(anchorSuccess);
            setTimeout(() => { this.setState({ showThankYou: true }, function() {
                let anchor = document.getElementById("gate-fee-checkout-section");
                this.props.showThankYou();
                zenscroll.intoView(anchor);
            }) }, 1500);
        }
        if (stepTwoStep === 1 && this.state.stepOneStep === 5 ) {
            let anchor = document.getElementById("checkout-subtitle");
            zenscroll.center(anchor);
        }
    }

    handleClickDot(num) {
        this.setState({ stepOneStep: num }); 
    }

    handleBack() {
        let stepOneStep = this.state.stepOneStep;
        stepOneStep--;
        this.setState({ stepOneStep: stepOneStep});
    }

    //Progress bar
    handleProgressBar() {
        if (this.state.stepOneStep < 2 && this.state.stepOneStep > 0) return "progress-bar phase-1";
        else if (this.state.stepOneStep === 2 || this.state.stepOneStep === 3) return "progress-bar phase-2";
        else if (this.state.stepOneStep >= 4) return "progress-bar complete";
        else return "progress-bar";
    }

    //Render Products You Want section
    renderBlockSection() {
        const isEditingProducts = this.state.isEditingProducts;
        let allProductThreeFiveMap = Object.assign({}, indexMapThreeFive);
        let allProductMap = Object.assign({}, indexMapProducts);
        const allProductOptionsThreeFive = Object.keys(allProductThreeFiveMap).sort().map(index => {
            let name = util.capitalize(productTypeUpdated[index - 1].replace(".svg", "").replace("-", " ")); 
           return (
                <div key={ index } className="option full" >
                <SelectButton name={ name } selectable={ isEditingProducts }
                    selected={ this.state.productTypes && this.state.productTypes.indexOf(parseInt(index, 10)) > -1 } id={ "product-" + index }
                    onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>    
            );
        });

        const allProductOptions = Object.keys(allProductMap).sort().map(index => {
            let name = util.capitalize(productTypeUpdated[index - 1].replace(".svg", "").replace("-", " ")); 
            return(
                <div key={ index } className="option" >
                    <SelectButton name={ name } selectable={ isEditingProducts }
                    selected={ this.state.productTypes && this.state.productTypes.indexOf(parseInt(index, 10)) > -1 } id={ "product-" + index }
                    onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });

        let customIconMap = this.state.productTypes.map((productId) => {
            return(
                <div className="regimen-icon">
                    <div className="regimen-icon-svg"><img alt={ indexMapProductsFile[productId] } src={"/images/gate/prodicons/" + indexMapProductsFile[productId] + ".svg"} /></div>
                    <div className="caption">{indexMapProductsRef[productId]}</div>
                </div>
            );
        });
        if (this.state.productTypes[0] === 13 || this.state.productTypes[0] === 14) {
            return(
                <div className={ this.state.stepOneStep > 1 ? "rendered-block-section transition-out" : this.state.stepOneStep === 1 ? "rendered-block-section" : "rendered-block-section collapsed" }>
                    <h4>Products you want</h4>
                    <div className="content-section bottom-section options">
                        <div className={ !this.state.isEditingProducts ? "edit-button" : "edit-button editing" }><button onClick={ this.handleEditClick }>{ !this.state.isEditingProducts ? "Edit" : "Save" }</button></div>
                        <div className="regimen-icons">
                            <div className="regimen-row">
                                <div className="regimen-icon">
                                    <div className="regimen-icon-svg"><img alt="Cleanser" src="/images/gate/prodicons/cleanser.svg" /></div>
                                    <div className="caption">Cleanser</div>
                                </div>
                                <div className="regimen-icon">
                                    <div className="regimen-icon-svg"><img alt="Moisturizer" src="/images/gate/prodicons/moisturizer.svg" /></div>
                                    <div className="caption">Moisturizer</div>
                                </div>
                                <div className="regimen-icon">
                                    <div className="regimen-icon-svg"><img alt="SPF" src="/images/gate/prodicons/spf.svg" /></div>
                                    <div className="caption">SPF</div>
                                </div>
                            </div>
                            {
                                this.state.productTypes[0] === 14 ?
                                <div className="regimen-row">
                                    <div className="regimen-icon">
                                        <div className="regimen-icon-svg"><img alt="Toner" src="/images/gate/prodicons/toner.svg" /></div>
                                        <div className="caption">Toner</div>
                                    </div>
                                    <div className="regimen-icon">
                                        <div className="regimen-icon-svg"><img alt="Exfoliator" src="/images/gate/prodicons/exfoliator.svg" /></div>
                                        <div className="caption">Exfoliator</div>
                                    </div>
                                </div> : null

                            }
                        </div>
                        <div className="regimen-icons deselected-products">
                            {isEditingProducts && allProductOptionsThreeFive}
                            {isEditingProducts && 
                                <div className="create-your-own">
                                    <div className="title create">Create Your Own</div>
                                    {allProductOptions}
                                </div>
                            }
                        </div>
                        
                    </div>
                    <div className="checkout-block-section budget-section">                      
                        <form >
                            <label>
                              <h4>Budget per product</h4>
                              <select value={ this.state.inputValue } onChange={ this.handleDropdown }>
                                {/* <option value={1}>{ "<= $30" }</option> */}
                                <option value={2}>{ "<= $50" }</option>
                                <option value={3}>{ "<= $75" }</option>
                                <option value={4}>{ "I'm open" }</option>
                              </select>
                            </label>
                          </form>
                    </div>
                    <div className="checkout-block-button">
                        <button onClick={ this.handleSubmitStepOne }>Confirm</button>
                    </div>

                    {/*                                    
                    <div className="confirm-msg">
                        <h5>When will I receive my products?</h5>
                        <p>After you receive your personalized skincare regimen via text, you will have 3 days to confirm your order. You can modify the recommended products or opt out.</p>
                    </div>
                     */}
                     
                </div>
            );
        } else {
            return(
                <div className={  this.state.stepOneStep > 1 ? "rendered-block-section transition-out" : this.state.stepOneStep === 1 ? "rendered-block-section" : "rendered-block-section collapsed" }>
                    <h4>Products you want</h4>
                    <div className="content-section bottom-section">
                        <div className={ !this.state.isEditingProducts ? "edit-button" : "edit-button editing" }><button onClick={ this.handleEditClick }>{ !this.state.isEditingProducts ? "Edit" : "Save" }</button></div>
                        <div className="regimen-icons">
                            <div className="regimen-row custom-regimen">
                                { customIconMap }
                            </div>

                            <div className="deselected-products">
                                {isEditingProducts && allProductOptionsThreeFive}
                                {isEditingProducts && 
                                    <div className="create-your-own">
                                        <div className="title create">Create Your Own</div>
                                        { allProductOptions }
                                    </div>
                                }
                            </div>
                        
                        </div>
                    </div>
                    <div className="checkout-block-section budget-section">                       
                        <form onChange={ this.handleDropdown }>
                            <label>
                              <h4>Budget per product</h4>
                              <select value={this.state.inputValue} /*onChange={this.handleChange}*/>
                                {/* <option selected={this.state.inputValue === 1 ? "selected" : null} value={1}>{ "<= $30" }</option> */}
                                <option selected={this.state.inputValue === 2 ? "selected" : null} value={2}>{ "<= $50" }</option>
                                <option selected={this.state.inputValue === 3 ? "selected" : null} value={3}>{ "<= $75" }</option>
                                <option selected={this.state.inputValue === 4 ? "selected" : null} value={4}>{ "I'm open" }</option>
                              </select>
                            </label>
                          </form>
                    </div>
                    <div className="checkout-block-button">
                        <button onClick={ this.handleSubmitStepOne }>Confirm</button>
                    </div>
                </div>
            );
        }
    }


    selectPasIcon(id) {
        const splits = id.split("-");
        let index = splits[1];

        let productTypes = this.state.productTypes;
        index = parseInt(index, 10);
        if ((index !== 13) && (index !== 14)) {
            let indexThirteen = productTypes.indexOf(13);
            let indexFourteen = productTypes.indexOf(14);
            if (indexThirteen > -1) productTypes.splice(indexThirteen, 1);
            if (indexFourteen > -1) productTypes.splice(indexFourteen, 1);
            productTypes.push(parseInt(index,10));
            this.setState({ productTypes: productTypes });
        } else {
            productTypes = [];
            productTypes.push(index);
            this.setState({ productTypes: productTypes });
        }
        
    }

    deselectPasIcon(id) {
        const splits = id.split("-");
        let index = splits[1];

        let productTypes = this.state.productTypes;
        index = parseInt(index, 10);
        productTypes.splice(productTypes.indexOf(index), 1);
        if(this.state.productTypes.indexOf(index) === -1) productTypes.slice(this.state.productTypes.indexOf(index), 1);          
        this.setState({ productTypes: productTypes });    
    }

    saveProducts() {
        const productTypes = this.state.productTypes;
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-product-types?user-id=" + userId + "&options=" + productTypes;
        if (productTypes.length === 0) {
            alert("You must select at least one product type.");
            return;
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ isEditingProducts: false });
                this.fetchResult();
                let anchor = document.getElementById("text-service-js");
                zenscroll.center(anchor);
            } else {
                alert("There is a problem to save the products. Please try again.");
            }
        });
    }

    saveBudget() {
        const userId = localStorage.getItem("user_id");
        const url = "/api/user-profiles";
        fetch(url, {
            method: 'PATCH',
            headers: {
                'x-auth-token': Api.auth_tokenManager(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: userId,
                budgetId: parseInt(this.state.inputValue, 10)
            })
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.fetchResult();
            } else {
                alert("There is a problem saving budget preferences. Please try again.");
            }
        });
    }

    handleEditClick = () => {
        if (this.state.isEditingProducts) {
            this.saveProducts();
        }
        else {
            this.setState({ isEditingProducts: true });
        }
    }


    handleSubmitStepOne() {
        if (this.state.isEditingProducts) {
            this.saveProducts();
        }
        this.changeStepOneStep();
    }

    handleChangeAdddressInput = (e) => {
        e.persist();
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmitShipping = () => {
        const userId = localStorage.getItem("user_id");
        const firstName = this.state.showShippingAddressSection ? this.state.fnameShipping : this.state.firstName;
        const lastName = this.state.showShippingAddressSection ? this.state.lnameShipping : this.state.lastName;
        const address1 = this.state.showShippingAddressSection ? this.state.addressOneShipping : this.state.addressOne;
        const address2 = this.state.showShippingAddressSection ? this.state.addressTwoShipping : this.state.addressTwo;
        const city = this.state.showShippingAddressSection ? this.state.cityShipping : this.state.city;
        const state = this.state.showShippingAddressSection ? this.state.regionShipping : this.state.region;
        const country = this.state.showShippingAddressSection ? this.state.countryShipping : this.state.country;
        const zip = this.state.showShippingAddressSection ? this.state.zipShipping : this.state.zip;
        fetch('/api/shipping-addresses', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                "userId": userId,
                "firstName": firstName,
                "lastName": lastName,
                "address1": address1,
                "address2": address2,
                "city": city,
                "state": state,
                "stateCode": stateData[state],
                "country": country,
                "zip": zip
            })
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                return;
            } else {
                this.setState({ disablePurchaseButton: false });
                throw new Error("Response status issue.");
            }
        })
        .catch(err => {
            console.log('There was a problem saving your shipping address: ' + err);
        });
        
    }

    saveGateFeeAmount(amount,timestampValue) {
        const url = '/api/gate-fees';
        const userId = localStorage.getItem("user_id");
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                "userId": userId,
                "amount": parseFloat(amount).toFixed(2),
                "timestamp": timestampValue
            })
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                return;
            } else {
                throw new Error("Response status issue.");
            }
        })
        .catch(err => {
            console.log('There was a problem saving your  consultation fee payment: ' + err);
        });
    }


    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ disablePurchaseButton: true });
        if (this.state.country !== "Canada") {
          this.confirmZip(this.state.zip, this.state.region,this.state.country)
          .then(response => {
              if (!response) {
                  this.setState({ disablePurchaseButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your billing address state." });
                  return;
              } else {
                  if (this.state.showShippingAddressSection) {
                      this.confirmZip(this.state.zipShipping, this.state.regionShipping, this.state.countryShipping)
                      .then(response => {
                          if (!response) {
                              this.setState({ disablePurchaseButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your shipping address state." });
                              return;
                          } else {
                              if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === '')))
                              {
                                  this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
                                  return;
                              } else {
                                  this.handleSubmitShipping();
                              }
                              
                              if (!this.state.userPaid) {
                                  let name = this.state.firstName + " " + this.state.lastName;
                                  this.setState({ errorMessageShow: false });
                                  this.props.stripe.createToken({
                                      name: name,
                                      address_line1: this.state.addressOne,
                                      address_line2: this.state.addressTwo,
                                      address_city: this.state.city,
                                      address_country: this.state.country,
                                      address_state: this.state.region
                                  })
                                  .then(({token}) => {
                                      this.handlePayment(token);
                                  })
                                  .catch((err) => {
                                      //Creating token
                                      this.setState({ disablePurchaseButton: false });
                                      this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                                  });
                              } else {
                                  //Submitted payment previously
                                  this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
                              }
                          }
                      });
                  } else {
                  if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === '')))
                          {
                              this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
                              return;
                          } else {
                              this.handleSubmitShipping();
                          }
                          
                          if (!this.state.userPaid) {
                              let name = this.state.firstName + " " + this.state.lastName;
                              this.setState({ errorMessageShow: false });
                              this.props.stripe.createToken({
                                  name: name,
                                  address_line1: this.state.addressOne,
                                  address_line2: this.state.addressTwo,
                                  address_city: this.state.city,
                                  address_country: this.state.country,
                                  address_state: this.state.region
                              })
                              .then(({token}) => {
                                  this.handlePayment(token);
                              })
                              .catch((err) => {
                                  //Creating token
                                  this.setState({ disablePurchaseButton: false });
                                  this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                              });
                          } else {
                              //Submitted payment previously
                              this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
                          }
                  }
                  
              }
          });
      } else {
        if (this.state.showShippingAddressSection && this.state.countryShipping === 'United States') {
            this.confirmZip(this.state.zipShipping, this.state.regionShipping, this.state.countryShipping)
            .then(response => {
                if (!response) {
                    this.setState({ disablePurchaseButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your shipping address state." });
                    return;
                } else {
                    if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === '')))
                    {
                        this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
                        return;
                    } else {
                        this.handleSubmitShipping();
                    }
                    
                    if (!this.state.userPaid) {
                        let name = this.state.firstName + " " + this.state.lastName;
                        this.setState({ errorMessageShow: false });
                        this.props.stripe.createToken({
                            name: name,
                            address_line1: this.state.addressOne,
                            address_line2: this.state.addressTwo,
                            address_city: this.state.city,
                            address_country: this.state.country,
                            address_state: this.state.region
                        })
                        .then(({token}) => {
                            this.handlePayment(token);
                        })
                        .catch((err) => {
                            //Creating token
                            console.log(err);
                            this.setState({ disablePurchaseButton: false });
                            this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                        });
                    } else {
                        //Submitted payment previously
                        this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
                    }
                }
            });
          } else {
            if ((this.state.country === '' || this.state.region === '') || (this.state.showShippingAddressSection && (this.state.countryShipping === '' || this.state.regionShipping === '')))
              {
                  this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
                  return;
              } else {
                  this.handleSubmitShipping();
              }
              
              if (!this.state.userPaid) {
                  let name = this.state.firstName + " " + this.state.lastName;
                  this.setState({ errorMessageShow: false });
                  this.props.stripe.createToken({
                      name: name,
                      address_line1: this.state.addressOne,
                      address_line2: this.state.addressTwo,
                      address_city: this.state.city,
                      address_country: this.state.country,
                      address_state: this.state.region
                  })
                  .then(({token}) => {
                      this.handlePayment(token);
                  })
                  .catch((err) => {
                      //Creating token
                      this.setState({ disablePurchaseButton: false });
                      this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
                  });
              } else {
                  //Submitted payment previously
                  this.setState( { errorMessageShow: true, errorMessage: "You have already submitted your $10 skincare consultation fee." } );
              }
          }
      }
    }

    //Confirm Check
    handleCheckChange() {
        this.setState({ defaultPurchaseConfirmed: !this.state.defaultPurchaseConfirmed });
    }

    //Checkbox for Showing Shipping Address Section
    handleCheckChangeShippingAddress() {
        this.setState({ showShippingAddressSection: !this.state.showShippingAddressSection });
    }


    //Dropdown
    handleDropdown(e) {
        this.setState({ inputValue: e.target.value }, function() {
            this.saveBudget();
        });
    }

    handleBlurInputCenter() {
        let anchor = document.getElementById("inputPhoneNumber");
        zenscroll.center(anchor);
    }
    handleBlurInputCodeCenter() {
        let anchor = document.getElementById("inputPhoneCode");
        zenscroll.center(anchor);
    }

    //Phone Number Confirm
    renderPhoneNumber() {
        return(
            <div className="rendered-phone-section">
                
                <div className={ this.state.stepOneStep > 2 ? "rendered-block-section transition-out" : this.state.stepOneStep === 2 ? "rendered-block-section" : "rendered-block-section collapsed" }>
                    <button className="back" onClick={ this.handleBack } >{ "< Back" }</button>
                    <h4> Enter your phone number to verify</h4>
                    
                    <div className="Gate-phoneNumber-area">
                        <div className="select-country-area" style={{ backgroundColor: '#fff',fontSize:'14px'}}>
                            <div className="select-country-text" style={{color:'#272d67',fontSize:'14px'}}>+{util.getCountry(this.state.phoneCountry)} </div>
                            <select className="select-country-phone" name="phoneCountry" onChange={this.handleChangePhoneInput}>
                            <option value="US">US (+1)</option>
                            <option value="Canada">Canada (+1)</option>
                            <option value="UK">UK (+44)</option>
                            </select>
                            <i className="fa fa-caret-down fa-lg select-country-array"></i>
                        </div>
                        <input id="inputPhoneNumber" placeholder="Please enter Phone" style={{ textAlign: 'left'}} name="phoneNumber" onBlur={this.handleBlurInputCenter} onChange={this.handleChangePhoneInput} value={this.state.phoneNumber} onKeyDown={this.handleKeyDownPhoneInput}/>
                    </div>
                    
                    <div className="checkout-block-button">
                        <button onClick={ this.handlePhoneNumSubmit }>Send Code</button>
                    </div>
                </div>
                <div className={ this.state.stepOneStep > 3 ? "rendered-block-section verification transition-out" : this.state.stepOneStep === 3 ? "rendered-block-section verification" : "rendered-block-section verification collapsed" }>
                    <button className="back" onClick={ this.handleBack } >{ "< Back" }</button>
                    <h4>Verification code</h4>
                    <div className="phone-subtitle">Please enter the verification code sent to   +{util.getCountry(this.state.phoneCountry)} { this.state.phoneNumber }</div>
                    <input name="phoneNumber" id="inputPhoneCode" onBlur={this.handleBlurInputCodeCenter} onChange={this.handleConfirmInput} value={this.state.confirmCode} />
                    <div className="checkout-block-button">
                        <button onClick={ this.handleConfirmCodeSubmit }>Confirm</button>
                    </div>
                    <div className="resend-button">
                        <button onClick={ this.handleResend } className="resend">Resend Code</button>
                    </div>
                    {
                        !this.state.codeMatch &&
                        <div className="error-confirm">
                            The verification code is incorrect.
                        </div>
                    }
                </div>
                <div className={ this.state.stepOneStep > 4 ? "rendered-block-section transition-out" : this.state.stepOneStep === 4 ? "rendered-block-section" : "rendered-block-section collapsed" }>
                    <h4>Success!</h4>
                </div>
            </div>
        );
    }

    handleChangePhoneInput = (e) => {
        let output = e.target.value;
        let phoneOutput;
        if (e.target.name === 'phoneNumber') {
            let input = output;
            input = input.replace(/[^0-9]/g, '');

            let area = input.substr(0,3);
            let pre = input.substr(3,3);
            let last = input.substr(6,4);

            if(this.state.phoneCountry == 'UK'){
                phoneOutput = output.substr(0, 10);
              }else{
                if (area.length < 3) {
                  phoneOutput = "(" + area;
                } else if (area.length === 3 && pre.length < 3) {
                  phoneOutput = "(" + area + ") " + pre;
                } else if (area.length === 3 && pre.length === 3) {
                  phoneOutput = "(" + area + ") " + pre + "-" + last;
                }
            }

            // phoneOutput = input;
            this.setState({ [e.target.name]: phoneOutput });
            return;
        }else if(e.target.name === "phoneCountry"){
            this.setState({
              phoneNumber: ''
            });
        }

        this.setState({ [e.target.name]: output });
        e.preventDefault();
        e.stopPropagation();
    }

    handleKeyDownPhoneInput = (e) => {
        let key = e.keyCode;
        if (key === 46) {
            let output = e.target.value;
            if (output.slice(-1) === ' ') {
                output = output.substring(0, output.length - 2);
            } else {
                output = output.substring(0, output.length - 1);
            }
            this.setState({ [e.target.name]: output });
        } else if (key === 8) {
            let output = e.target.value;
            let lastChar = output.charAt(output.length - 1);
            if (lastChar === '-' || lastChar === '(' || lastChar === ')') {
                output = output.substring(0, output.length - 1);
            } else if (lastChar === ' ') {
                output = output.substring(0, output.length - 2);
            }
            this.setState({ [e.target.name]: output });
        }
        e.stopPropagation();
    }

    handlePhoneNumSubmit() {
        const randomNum = Math.floor(Math.random()*90000) + 10000;
        const firstName = this.props.firstName;
        const lastName = this.props.lastName;
        const email = this.props.email;
        const phoneNumber = this.state.phoneNumber.replace("(", "").replace(")", "").replace(" ", "");

        this.addMobileUserToAirtable(firstName, lastName, phoneNumber, email, randomNum);
        this.sendConfirmationCodeEntryToZapier(firstName, lastName, phoneNumber, email, randomNum);
        this.sendConfirmationToApi(phoneNumber, randomNum);
        this.changeStepOneStep();
    }

    handleResend() {
        const randomNum = Math.floor(Math.random()*90000) + 10000;
        const firstName = this.props.firstName;
        const lastName = this.props.lastName;
        const email = this.props.email;
        const phoneNumber = this.state.phoneNumber;

        this.addMobileUserToAirtable(firstName, lastName, phoneNumber, email, randomNum);
        this.sendConfirmationCodeEntryToZapier(firstName, lastName, phoneNumber, email, randomNum);
        this.sendConfirmationToApi(phoneNumber, randomNum);
    }

    addMobileUserToAirtable(firstName, lastName, phoneNumber, email, verificationCode) {
        const url = 'https://api.airtable.com/v0/appcB3FMnoHGLoRgj/Verification%20Flow';
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + process.env.REACT_APP_AIRTABLE_API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "fields": {
                    "First Name": firstName,
                    "Last Name": lastName,
                    "Phone": "+"+util.getCountry(this.state.phoneCountry)+' '+phoneNumber,
                    "Email": email,
                    "Verification Code": verificationCode.toString()
                }
            })
        });
    }

    sendConfirmationCodeEntryToZapier(firstName, lastName, phoneNumber, email, verificationCode) {
        const url = 'https://hooks.zapier.com/hooks/catch/2569749/al95xn/';
        // const url = 'https://hooks.zapier.com/hooks/catch/2569749/oyippjp/';

        const phone = "+"+util.getCountry(this.state.phoneCountry)+" " + phoneNumber;
        fetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    "First Name": firstName,
                    "Last Name": lastName,
                    "Phone": phone,
                    "Email": email,
                    "Verification Code": verificationCode.toString()
                })

        })
        .catch(function(err) {
            alert("There was a problem getting your info. Please try again.");
        });

    }

    sendConfirmationToApi(phone, randomNum) {
        const userId = localStorage.getItem("user_id");
        const code = randomNum.toString();
        fetch('/api/user-profiles/phone-number-verification', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                    "userId": parseInt(userId, 10),
                    "phoneNumber": phone,
                    "phoneNumberVerificationCode": code,
                    "regionId":Number(util.transformationCountryNumberId(this.state.phoneCountry)),
                })
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ codeToVerify: randomNum });
            }
        });
    }

    //Confirmation Code
    handleConfirmInput = (e) => {
        let input = e.target.value;
        input = input.replace(/[^0-9]/g, '');
        this.setState({
            confirmCode: input
        });
    }

    //Confirm code submit
    handleConfirmCodeSubmit() {
        let confirmCode = parseInt(this.state.confirmCode, 10);
        const userId = localStorage.getItem("user_id");
        const url = '/api/user-profiles/phone-number-verification?user-id=' + userId + '&verification-code=' + confirmCode;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json()).then(responseJson => {
            if (responseJson) {
                this.setState({
                    codeMatch: true
                }, this.changeStepOneStep);
            } else {
                this.setState({
                    codeMatch: false
                });
            }
        })
        .catch(function(err) {
            alert("There was a problem getting the confirmation code. Please try again.");
        });
    }

    confirmZip = (zip, state,country) => {
        const stateCode = stateData[state];
        const url = `/api/taxjar/zip-state-match?zip=${zip}&state=${stateCode}&country=${country}`
        return fetch(url , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                this.setState({ disablePurchaseButton: false });
                throw new Error("Error confirming zip.")
            }
            
        }).then(responseJson => {
            return responseJson;
        }).catch(function(err) {
            alert("There was a problem confirming your address. Please try again.");
        });
    }

    //Thank you Step 1
    renderThankYouMessage() {
        let customIconMap;
        if (this.state.productTypes[0] === 13 || this.state.productTypes[0] === 14) {
            customIconMap = (
                <div className="regimen-icons">
                        <div className="regimen-icon">
                            <div className="regimen-icon-svg"><img alt="Cleanser" src="/images/gate/prodicons/cleanser.svg" /></div>
                            <div className="caption">Cleanser</div>
                        </div>
                        <div className="regimen-icon">
                            <div className="regimen-icon-svg"><img alt="Moisturizer" src="/images/gate/prodicons/moisturizer.svg" /></div>
                            <div className="caption">Moisturizer</div>
                        </div>
                        <div className="regimen-icon">
                            <div className="regimen-icon-svg"><img alt="SPF" src="/images/gate/prodicons/spf.svg" /></div>
                            <div className="caption">SPF</div>
                        </div>

                        {
                            this.state.productTypes[0] === 14 &&
                            <div className="regimen-icon">
                                <div className="regimen-icon-svg"><img alt="Toner" src="/images/gate/prodicons/toner.svg" /></div>
                                <div className="caption">Toner</div>
                            </div>
                        }
                        {
                            this.state.productTypes[0] === 14 &&
                            <div className="regimen-icon">
                                <div className="regimen-icon-svg"><img alt="Exfoliator" src="/images/gate/prodicons/exfoliator.svg" /></div>
                                <div className="caption">Exfoliator</div>
                            </div>
                        }

                </div>
            );
        } else {
            customIconMap = this.state.productTypes.map((productId) => {
                return(
                    <div className="regimen-icon">
                        <div className="regimen-icon-svg"><img alt={ indexMapProductsFile[productId]  } src={"/images/gate/prodicons/" + indexMapProductsFile[productId] + ".svg"} /></div>
                        <div className="caption">{indexMapProductsRef[productId]}</div>
                    </div>
                );
            });
        }
        const budgetMap = {
            1: "<= $30",
            2: "<= $50",
            3: "<= $75",
            4: "I'm open"
        }
        return(
            <div className="rendered-thank-you-section">
                <div className={ this.state.stepOneStep === 5 ? "rendered-block-section" : "rendered-block-section collapsed" }>
                    <h3>Thanks for confirming your information!</h3>
                    <div className="thank-you-row">
                        <div className="thank-you-block thank-you-title">Products you want:</div>
                        <div className="thank-you-block  regimen-icons">
                            { customIconMap }
                        </div>
                    </div>
                    <div className="thank-you-row">
                        <div className="thank-you-block  thank-you-title">Budget per product:</div>
                        <div className="thank-you-block thank-you-budget">{ budgetMap[this.state.inputValue] }</div>
                    </div>
                    <div className="thank-you-row">
                        <div className="thank-you-block thank-you-title">Your phone number</div>
                        <div className="thank-you-block thank-you-phone">+{util.getCountry(this.state.phoneCountry)} { this.state.phoneNumber }</div>
                    </div>
                </div>
            </div>
        );
    }

    /*** STEP 2 ***/
    //Render section
    renderPaymentSection() {
        return(
            <div className={ this.state.stepTwoStep === 3 ? "checkout-block-content transition-out" : this.state.stepTwoStep < 3 ? "checkout-block-content" : "checkout-block-content collapsed" }>
                <div className="checkout-block-content-section top-checkout-section">
                    <h3 id="skincare-js">One-on-one consultation fee (credited towards your first purchase)</h3>
                    <div className="checkout-subtitle" id="checkout-subtitle">
                        We are confident that you will love your <span id="text-service-js">service</span> and products. But if you are unhappy with your recommendations we will refund your $10 skincare consultation fee.
                    </div>
                </div>
                <div className="checkout-block-content-section bottom-checkout-section" id="bottom-checkout-section-js">
                    <div className="order-items">
                        <div className="order-item curation">
                            <div className="item">
                                <div className="item-name">Skincare consultation fee</div>
                                <div className={ this.state.amountAvailableForDiscount > 0 ? "item-price strikethrough" : "item-price" }>$10</div>
                            </div>
                            <div className="item-descr">-credited towards your first purchase</div>
                        </div>
                        <div className="order-item discount">
                            {(this.state.amountAvailableForDiscount) > 0 ? <div className="item you-save">
                                <div className="item-name discount-offer">Promo code</div>
                                <div className="discount-amount">{ this.state.discountType === "percentage" ? "-" + this.state.amountAvailableForDiscount + "% ($" +  parseFloat((10 * (this.state.amountAvailableForDiscount / 100))).toFixed(2) + ")" : "-$" + this.state.amountAvailableForDiscount }</div>
                            </div> : null}
                        </div>
                        <div className="order-item total">
                            {(this.state.amountAvailableForDiscount) > 0 ? <div className="item you-save">
                                <div className="item-name total-name">Total</div>
                                <div className="item-price discount-amount">${ this.state.discountType === "percentage" ? 10 * ((100 - this.state.amountAvailableForDiscount) / 100) : 10 - this.state.amountAvailableForDiscount }</div>
                            </div> : null}
                        </div>
                        <div className="confirmation-msg">
                        </div>
                    </div>
                    {/* <div className="confirmation-msg-text-alter">Due to COVID-19 state-wide restrictions,we are unable to ship to Canada at the moment</div> */}
                    <div className={ this.state.stepTwoStep > 1 ? "checkout-block-button hidden" : "checkout-block-button" } >
                        <button onClick={ this.handleSubmitStepTwo }>Submit Payment</button>
                    </div>
                    <div className={ this.state.stepTwoStep < 2 ? "checkout-form hidden" : "checkout-form" }>
                        <form id="checkout-form" onSubmit={this.handleSubmit}>
                            <div className="block-content checkout">
                                <div className="credit-card-header">
                                    <h4>Payment method</h4>
                                </div>
    
                                <div className="credit-card-logos">
                                    <div className="credit-card-logo"><img alt="Visa" src="/images/gate/visa.png" /></div>
                                    <div className="credit-card-logo"><img alt="Mastercard" src="/images/gate/mastercard.png" /></div>
                                    <div className="credit-card-logo"><img alt="Discover" src="/images/gate/discover.png" /></div>
                                    <div className="credit-card-logo"><img alt="American Express" src="/images/gate/amex.png" /></div>
                                    <div className="credit-card-logo"><img alt="JCB" src="/images/gate/jcb.png" /></div>
                                    <div className="credit-card-logo"><img alt="Diner's" src="/images/gate/diners.png" /></div>
                                </div>

                                <label>
                                    <div className="card-label number">Credit Card Number</div>
                                    <CardElement
                                        style={{
                                            base: {
                                                color: '#272d67',
                                                fontSize: '12px',
                                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif'
                                            }
                                        }}
                                        hidePostalCode={ true }
                                    />
                                </label>

                                <div className="fname-lname-row">
                                        <label>
                                            <div className="card-label addressOne">First Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="firstName" value={ this.state.firstName } type="text" placeholder="" required/>
                                        </label>

                                        <label>
                                            <div className="card-label addressOne">Last Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="lastName" value={ this.state.lastName } type="text" placeholder="" required/>
                                        </label>
                                    </div>
                                <label>
                                   
                                    <div className="card-label promo-code">Promo Code</div>
                                     <div className="promo-code-row">
                                        <input className="promo-input" onChange={ this.handleChangeAdddressInput } onFocus={ () => { this.setState({ showPromoSuccessMessage: false, promoCodeError: '' }) } } name="promoCode" value={ this.state.promoCode } type="text" placeholder="" />
                                        <button onClick={ this.checkIfPromoCodeExists }>Redeem Code</button>
                                    </div>
                                    {
                                        this.state.showPromoSuccessMessage ?
                                            this.state.promoCodeError.length === 0 ?
                                                <div className="promo-success-message">Promo code { this.state.promoCodeSaved } redeemed!</div> :
                                                <div className="promo-success-message promo-error">{ this.state.promoCodeError }</div> 
                                        : null
                                    }
                                </label>

                                <div className="address-section billing-info">
                                    <div className="credit-card-header">
                                        <h4>Billing info</h4>
                                    </div>

                                    <label>
                                        <div className="card-label addressOne">Address Line 1 (Street)</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressOne" value={ this.state.addressOne } type="text" placeholder="" required />
                                    </label>

                                    <label>
                                        <div className="card-label addressTwo">Address Line 2 (Apt Number)</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressTwo" value={ this.state.addressTwo }type="text" placeholder="" />
                                    </label>

                                    <label>
                                        <div className="card-label city">City</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="city" value={ this.state.city } type="text" placeholder="" required />
                                    </label>

                                    <div className="country-state-zip">
                                        <label>
                                            <div className="card-label country">Country</div>
                                            <CountryDropdown
                                                value={this.state.country}
                                                defaultOptionLabel="Select Country"
                                                onChange={(val) => this.selectCountry(val)}
                                                whitelist={["US", "CA", "GB"]}
                                            />
                                        </label>
                                        <label>
                                            <div className="card-label state">State</div>
                                            <RegionDropdown
                                                country={this.state.country}
                                                value={this.state.region}
                                                defaultOptionLabel={this.state.country === "United States" ? "State" : "Province"}
                                                onChange={(val) => this.selectRegion(val)}
                                            />
                                        </label>
                                        <label>
                                        <div className="card-label zip">Zip Code</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="zip" value={ this.state.zip } type="text" placeholder="" maxLength="7" required />
                                        </label>
                                    </div>

                                    
                                </div>
                                <label className="checkbox-section">
                                    <input name="showShippingAddressSection" type="checkbox" checked={ this.state.showShippingAddressSection } onChange={ this.handleCheckChangeShippingAddress } />
                                    <div className="card-label show-address-section">My shipping address is different from my billing address</div>
                                </label>
                            
                                    
                                <div className={ this.state.showShippingAddressSection ? "address-section shipping-info expanded" : "address-section shipping-info" }>
                                    <div className="credit-card-header">
                                        <h4>Shipping info</h4>
                                    </div>

                                    <div className="fname-lname-row">
                                        <label>
                                            <div className="card-label addressOne">First Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="fnameShipping" value={ this.state.fnameShipping } type="text" placeholder="" required={ this.state.showShippingAddressSection } />
                                        </label>

                                        <label>
                                            <div className="card-label addressOne">Last Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="lnameShipping" value={ this.state.lnameShipping } type="text" placeholder="" required={ this.state.showShippingAddressSection } />
                                        </label>
                                    </div>

                                    <label>
                                        <div className="card-label addressOne">Address Line 1 (Street)</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressOneShipping" value={ this.state.addressOneShipping } type="text" placeholder="" required={ this.state.showShippingAddressSection } />
                                    </label>

                                    <label>
                                        <div className="card-label addressTwo">Address Line 2 (Apt Number)</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressTwoShipping" value={ this.state.addressTwoShipping }type="text" placeholder="" />
                                    </label>

                                    <label>
                                        <div className="card-label city">City</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="cityShipping" value={ this.state.cityShipping } type="text" placeholder="" required={ this.state.showShippingAddressSection } />
                                    </label>

                                    <div className="country-state-zip shipping-address">
                                        <label>
                                            <div className="card-label country">Country</div>
                                            <CountryDropdown
                                                value={ this.state.countryShipping }
                                                defaultOptionLabel="Select Country"
                                                onChange={(val) => this.selectCountryShipping(val)}
                                                whitelist={["US", "CA", "GB"]}
                                            />
                                        </label>
                                        <label>
                                            <div className="card-label state">State</div>
                                            <RegionDropdown
                                                country={ this.state.countryShipping }
                                                value={ this.state.regionShipping }
                                                defaultOptionLabel={this.state.countryShipping === "United States" ? "State" : "Province"}
                                                onChange={(val) => this.selectRegionShipping(val)}
                                            />
                                        </label>
                                        <label>
                                            <div className="card-label addressTwo">Zip Code</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="zipShipping" value={ this.state.zipShipping }type="text" placeholder="" maxLength="7" required={ this.state.showShippingAddressSection } />
                                        </label>
                                    </div>

                                    
                                    
                                </div>
                               
                            </div>

                            {   this.state.stepTwoStep >= 2 ?
                                <div className="payment-buttons">
                                   <div className="complete-purchase-button">
                                        <button id="PaymentRequestButton" /*onClick={ this.handleSubmit }*/ disabled={ this.state.disablePurchaseButton } >Submit</button>
                                    </div>
                                    {/*
                                        this.state.showPaymentRequestButton && util.isMobile(navigator.userAgent) ?
                                        <div className="apple-pay-section">
                                            <div className="or">or</div>
                                            <PaymentRequestButtonElement
                                                paymentRequest={ this.state.paymentRequest }
                                                className="payment-request-button"
                                                style={{
                                                    paymentRequestButton: {
                                                        type: 'buy'
                                                    }
                                                }}
                                            />
                                        </div> :
                                        null
                                    */}
                                </div> : 
                                null
                            }
                        </form>
                    </div>
                    
                </div>

                

                
            </div>
        );
    }

    //Change steps
    handleSubmitStepTwo() {
        this.changeStepTwoStep();
    }


    //Payment
    handlePayment(token) {
        const userId = localStorage.getItem("user_id");
        let amount = 10;

        let amountAfterDiscount = 0; 

        if (this.state.discountType !== "percentage") {
            amountAfterDiscount = amount - parseFloat(this.state.amountAvailableForDiscount) > 0 ? amount - parseFloat(this.state.amountAvailableForDiscount) : 0;
        } else {
            amountAfterDiscount = amount * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) >= 0 ? amount * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) : 0;
        }
        
        let finalAmount = this.state.amountAvailableForDiscount > 0 ? amountAfterDiscount : amount;
        var timestampValue = this.convertToStandardTime(token.created)
        fetch('/api/gate-fee', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                "userId": userId,
                "stripeToken": token.id,
                "amount": parseFloat(finalAmount).toFixed(2),
                "idempotencyKey": this.idempotencyKey,
                "timestamp": timestampValue,
            })
        })
        .then((response) =>
            {
                if ((response.headers.get('x-helloavaapp-error') && (response.status >= 400))) {
                    //Error handling
                    this.idempotencyKey = Api.getUUID();
                    this.setState({ disablePurchaseButton: false });
                    this.setState({ errorMessageShow: true, errorMessage: response.headers.get('x-helloavaapp-error') });
                    throw new Error(response.headers.get('x-helloavaapp-error'));
                } else {
                    this.setState({ userPaid: true, errorMessageShow: false }, function() {
                        if (this.state.promoCodeSaved.length > 0 && this.state.discountOncePerCustomer) this.redeemGiftCardInFull();
                        // if (process.env.REACT_APP_ENV === 'prod') {
                        //     ReactGA.event({
                        //         category: "Gate Fee",
                        //         action: "Paid",
                        //         label: "Paid Gate Fee",
                        //         value: 1
                        //     });
                        // }
                        this.changeStepTwoStep();
                        let anchor = document.getElementById("weVeReceived-js");
                        zenscroll.center(anchor);
                    });
                    this.saveGateFeeAmount(finalAmount,timestampValue);
                    // 这个放后台去调用了
                    // this.addPaidUsersToZapier(this.props.firstName, this.props.lastName, this.props.phoneNumber, token.created, this.props.email, parseFloat(finalAmount).toFixed(2));
                    
                    // document.getElementById("PaymentRequestButton").setAttribute("disabled", "disabled");
                    //Removed ReactPixel Purchase 07/22/2019
                    // ReactPixel.track('Purchase', {value: '10.00', currency: 'USD'});
                    // this.gtag_report_conversion_submitPayment();
                    window.fbq('trackCustom', 'PaidGateFee');
                    //Removed Purchase 07/22/2019
                    // window.fbq('track', 'Purchase', { value: '10.00', currency: 'USD' });
                }
                response.json();
            })
        .catch((err) => {
            //Error in payment/server issue
            this.setState( { errorMessageShow: true, errorMessage: "There was an error in making a payment. Please try again." } );
        });
    }

    selectCountry(val) {
      this.setState({ country: val });
    }

    selectCountryShipping(val) {
        this.setState({ countryShipping: val });
    }

    selectRegion(val) {
        this.setState({ region: val });
    }

    selectRegionShipping(val) {
        this.setState({ regionShipping: val });
    }


    renderErrorMessage() {
        if (this.state.errorMessageShow) return <div className="user-paid error-confirm">{ this.state.errorMessage }</div>;
        else return null;
    }

    renderPaymentConfirmation() {
        return(
            <div id="success-anchor" className={ this.state.stepTwoStep > 2 ? "checkout-block-content" : "checkout-block-content collapsed" } >
                <h3>Your skincare consultation fee has been submitted successfully!</h3>
            </div>
        );
    }

    render() {

       return(
            <div id="gate-fee-checkout">

                <div className={ this.state.showThankYou ? "checkout-block hide step-2" : this.state.stepTwoStep > 0 ? "checkout-block faded-out step-1" : "checkout-block step-1" }>
                    <div className={ this.state.stepTwoStep > 0 ? "checkout-mask active step-1" : "checkout-mask step-1" }></div>
                    <div className="step-header">STEP 1</div>
                    <div className={ this.state.stepOneStep > 4 ? "checkout-block-content checkout-transition-out" : "checkout-block-content" }>
                        <h3 id="checkout-block-content-title">Please confirm the information below</h3>
                        <div className="progress-bar-container" id="progress-bar-container">
                        <div className={ this.handleProgressBar() }>
                            <div className={ this.state.stepOneStep >= 1 ? "progress-bar-section section-1 active" : "progress-bar-section section-1" }>
                                <div onClick={ this.state.stepOneStep > 1 ? () => this.handleClickDot(1) : null } className="check-container">
                                    { this.state.stepOneStep > 1 ?  <i style={{fontSize:'28px', backgroundColor: '#fff'}}  class="fa fa-check-circle" aria-hidden="true"/>
                                    :  <div class="circle-icon" style={{ boxSizing: 'content-box',width:'20px',height:'20px'}}/>
                                    }
                                </div>
                                <div className={ this.state.stepOneStep >= 1  ? "progress-bar-caption details active" : "progress-bar-caption details" } >Details</div>
                            </div>
                            <div className={ this.state.stepOneStep >= 2 ? "progress-bar-section section-2 active" : "progress-bar-section section-2"  } >
                                <div className="check-container">
                                    { this.state.stepOneStep > 3 ? <i style={{fontSize:'28px', backgroundColor: '#fff'}}  class="fa fa-check-circle" aria-hidden="true"/>
                                    : <div class="circle-icon" style={{ boxSizing: 'content-box',width:'20px',height:'20px'}} />
                                    }
                                </div>
                                <div className={ this.state.stepOneStep >= 2  ? "progress-bar-caption phone-num active" : "progress-bar-caption phone-num" }>Phone</div>
                            </div>
                        </div>
                        </div>
                        <div className="checkout-block-content-products" id="checkout-block-content-products">
                            <div className="checkout-block-section choose-products-section">
                                { this.renderBlockSection() }
                                { this.renderPhoneNumber() }
                            </div>
        
                        </div>
                    </div>
                   
                    <div className={ this.state.stepOneStep !== 6 ? "checkout-block-content hidden" : "checkout-block-content" }>
                        { this.renderThankYouMessage() }
                    </div>
                </div>
                <div id="payment-block" className={ this.state.showThankYou ? "checkout-block hide step-2" : this.state.stepTwoStep > 0 ? "checkout-block step-2" : "checkout-block faded-out step-2" }>
                    <div className={ this.state.stepTwoStep > 0 ? "checkout-mask step-2" : "checkout-mask active step-2" }></div>
                    <div className="step-header">STEP 2</div>
                        { this.renderPaymentSection() }
                        { this.renderPaymentConfirmation() }
                        { this.renderErrorMessage() }
                </div>
                

                <div id="final-thank-you" className={this.state.showThankYou ? "final-thank-you-block" : "final-thank-you-block collapsed"}>
                    {/* <div className="thank-you-container">
                        <img alt="Thank You!" src="/images/gate/thank-you.png" id="thank-you-container-img"/>
                    </div> */}

{/*                     
                    <div className="thank-you-container-text" id="thank-you-container-text">Thank you!<br/> Schedule your consultation now</div>
 */}


                    <div className="checkout-block-button hidden checkout-button-group" >
                        <button className="chat-button" id="chat-button">
                            <img src="/images/gate/chat.svg" className="chat-button-img" /> 
                            <a target={ "_blank" } href="https://calendly.com/helloavaconsults">SCHEDULE MY CONSULTATION</a>
                        </button>
                    </div>

{/*                     
                    <div className="final-thank-you-message" id="final-thank-you-message" style={{marginTop:'1.5em'}}>
                        <p id="weVeReceived-js">
                        If you choose not to schedule your skin consultation, one of our skin advisors will reach out to you <span id="viaTextMessage_jd"> via text message within the next 24-48 hours </span> after reviewing your profile. Our normal business hours are Monday-Friday 9AM-8PM EST.  
                        </p>
                    </div>
 */}

                    <div className="checkout-block-button hidden checkout-button-group" >
                        <a href="/survey-result" className="checkout-a-back-to-skin">Back to my skin profile</a>
                        {/* <button><a href="/survey-result">Back to my skin profile</a></button>
                         <button className="chat-button">
                            <img src="/images/gate/chat.svg"/> 
                            <a target={ "_blank" } href="https://calendly.com/helloavaconsults">Schedule a live video consultation</a>
                        </button> */}
                    </div>
                    <div className="social-icons">
                        <div className="follow">Follow us:</div>
                        <div className="social-icon-group" style={{marginLeft:"11px"}}>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"><i class="fa fa-facebook-square" aria-hidden="true" style={{fontSize:'23px'}}/> </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"> <i class="fa fa-instagram" aria-hidden="true"  style={{fontSize:'23px'}}/></a>
                        </div>
                    </div>
                </div>
            
            </div>
                
            

       );
    }
}

export default injectStripe(GateFeeProcessing);



// WEBPACK FOOTER //
// ./src/views/onboarding/GateFeeProcessing.js